import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from "@material-ui/core/TextField";
import { sortLocationByCode } from '@actions/punch/location';
import { sortProjectByCode } from '@actions/punch/project';
import { sortActivityByCode } from '@actions/punch/activity';
import { sortDepartmentByCode } from '@actions/punch/department';
import { sortJobTitleByCode } from '@actions/punch/jobTitle';
import { paramPayment } from '@actions/timesheet/paramPayment';
import { addPunch, detailPunch, loadCombos, activePunch, confirmAttendance, confirmEmergency } from '@actions/punch';
import { IsEnglish } from '@utils/language';
import Button from '@material-ui/core/Button';
import ButtonLoad from 'react-bootstrap-button-loader';
import $ from 'jquery';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import styles from '@styles/punch.module.css';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import PunchGeolocation from './PunchGeolocation';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Slide from '@material-ui/core/Slide';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import PunchDetail from './PunchDetail';
import PunchReportRoot from '@components/punch/report/PunchReportRoot';
import { GetABCUsage } from '@utils/companyConfig';
import * as storage from '@utils/storage';
import AlertAlgo from '@controls/AlertSnack';
import * as statusCode from '@scripts/StatusCode';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faCircleCheck, faLightEmergencyOn, faLock, faEye, faEyeSlash } from "@fortawesome/pro-duotone-svg-icons";
import InputAdornment from '@material-ui/core/InputAdornment';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as GenericStatusCode from '@scripts/GenericStatusCode';
import { formatDate, formatNumber, formatCharactersDate } from '@utils';
import PunchFileUpload from '@components/punch/PunchFileUpload';

const stylesMat = theme => ({
    appBar: {
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    buttonSection: {
        paddingBottom: '0px!important'
    },
    form: {
        paddingBottom: '0px!important'
    },
    divLoading: {
        marginTop: '3px'
    },
    warningGeolocation: {
        backgroundColor: '#ff7b7b',
        color: '#ffffff',
        padding: '10px'
    }
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

class PunchForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            start: 0,
            end: 0,

            listComplete: [],
            locations: [],
            projects: [],
            activities: [],
            departments: [],
            jobTitles: [],
            profilesJobTitle: [],
            location: 0,
            project: '',
            activity: '',
            department: '',
            jobTitle: '',
            comments: '',
            loading: false,
            success: false,
            latitude: null,
            longitude: null,
            activeMessage: null,
            alertPunch: '',
            isActive: true,
            openGeolocation: false,
            openAttendanceConfirmation: false,
            openConfirmEmergency: false,
            currentPosition: null,
            currentZone: null,
            activeLocationID: null,
            activeJobTitle: '',
            activeDepartment: '',
            activeProject: '',
            activeActivityProject: null,
            activePunchID: null,
            isActivePunch: false,
            openDetail: false,
            dataDetail: [],
            abcUsage: false,
            linkProjectPActivity: false,
            isGeolocationAvailable: true,
            isGeolocationEnabled: true,
            coords: false,
            isPostCompleted: true,
            companyPayProject: false,
            companyPayActivity: false,
            useGeolocation: false,
            useGeolocationZone: false,
            useGeolocationMandatory: false,
            punchTime: false,
            useAttendanceConfirmation: false,
            useAttendanceConfirmationOnThisPunch: false,
            showPassword: false,
            password: '',
            isSSO: false,
            lastAttendanceConfirmation: null,
            useFilePunch: storage.getUseFilePunch(),
        };
        this.alert = React.createRef();
    }

    componentDidMount() {
        const interval = setInterval(async () => {
            //if (this.props.coords !== null) {
            clearInterval(interval);
            await this.loadParamPay();
            this.loadPage();
            //}
        }, 0)
    }

    loadParamPay = () => {
        return new Promise((resolve) => {
            paramPayment().then((result) => {
                const param = JSON.parse(result.param);

                this.setState({
                    companyPayProject: param.projectPay,
                    companyPayActivity: param.activityPay
                }, () => {
                    resolve();
                });
            });
        });
    }

    loadPage = () => {
        this.setState({
            abcUsage: GetABCUsage(),
            linkProjectPActivity: storage.getLinkProjectPActivity(),
            useGeolocation: storage.getUseGeolocation(),
            useGeolocationZone: storage.getUseGeolocationZone(),
            useGeolocationMandatory: storage.getUseGeolocationMandatory(),
            punchTime: storage.getPunchTime(),
            useAttendanceConfirmation: storage.getUseAttendanceConfirmation(),
            isSSO: storage.getIsSSO()
        }, async () => {
            const coords = await this.loadGeolocation();

            if (!coords.isGeolocationEnabled && this.state.useGeolocation && this.state.useGeolocationMandatory) {
                this.setState({ isActive: false });
                return;
            }

            var list = await loadCombos(this.state.location, coords.latitude, coords.longitude, coords.isGeolocationEnabled);

            var data = JSON.parse(list.result);
            this.setState({ listComplete: data });

            await this.loadProfileJobTitle();
            await this.loadProfilePayProject();
            await this.loadActivePunch();
            await this.loadLocations();
            await this.loadDepartments();
            await this.loadProjects();
            await this.loadActivities();
            await this.loadJobTitles();
            await this.resizeForm();
            this.setState({ isActive: false });
        })
    }

    loadGeolocation = () => {
        return new Promise(async (resolve) => {
            if (!this.state.useGeolocation) {
                this.setState({
                    latitude: 0,
                    longitude: 0,
                })
                resolve({ latitude: 0, longitude: 0, isGeolocationEnabled: false });
                return;
            }


            if ("geolocation" in navigator) {
                this.setState({ isGeolocationAvailable: true });

                const successCallback = (position) => {
                    //console.log('latitude:' + position.coords.latitude + '/ longitude:' + position.coords.longitude);
                    //console.log('isGeolocationAvailable: ' + this.props.isGeolocationAvailable + ' / isGeolocationEnabled: ' + this.props.isGeolocationEnabled);
                    this.setState({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        isGeolocationEnabled: true,
                        coords: true
                    }, () => {
                        resolve({ latitude: position.coords.latitude, longitude: position.coords.longitude, isGeolocationEnabled: true });
                    });
                }

                const errorCallback = () => {
                    console.log('No geolocation authorized!');
                    //console.log('isGeolocationAvailable: ' + this.props.isGeolocationAvailable + ' / isGeolocationEnabled: ' + this.props.isGeolocationEnabled);
                    this.setState({
                        isGeolocationEnabled: false
                    }, () => {
                        resolve({ latitude: 0, longitude: 0, isGeolocationEnabled: false });
                    });
                }

                navigator.geolocation.getCurrentPosition(successCallback, errorCallback, { timeout: 10000 });
            }
            else {
                this.setState({ isGeolocationAvailable: false });
                resolve({ latitude: 0, longitude: 0, isGeolocationEnabled: false });
            }
        })
    }

    loadActivePunch = (reload = false) => {
        return new Promise(async (resolve) => {
            let punch = null;

            if (reload) {
                const response = await activePunch();
                if (response.punch != null) {
                    punch = JSON.parse(response.punch);
                    punch = punch.activePunch;
                }
            }
            else {
                punch = this.state.listComplete.activePunch;
            }

            if (punch.punch != null) {
                const punchStart = new Date(formatCharactersDate(punch.punch.punchStart));
                const hourStart = formatNumber(punchStart.getHours(), 2);
                const minuteStart = formatNumber(punchStart.getMinutes(), 2);

                this.setState(
                    {
                        activeMessage: i18next.t('punch:activePunch') + ` ${hourStart}:${minuteStart}`,
                        alertPunch: "warning",
                        activeLocationID: punch.punch.geolocationId,
                        activeJobTitle: punch.punch.jobTitle,
                        activeDepartment: punch.punch.departmentCode,
                        activeProject: this.state.abcUsage ? punch.punch.abcProjectCode : punch.punch.projectCode,
                        activeActivityProject: this.state.abcUsage ? punch.punch.activityCode : this.state.companyPayActivity ? punch.activityP.sequenceId : '',
                        isActivePunch: true,
                        comments: '',
                        activePunchID: punch.punch.punchId
                    });

                if (this.state.useAttendanceConfirmation && punch.punchExtension?.useAttendanceConfirmation == 'O') {
                    const now = new Date();
                    const currentHour = now.getHours() + now.getMinutes() / 100.0;

                    const startHour = punch.personnelRequisitionDetail?.attendanceConfirmationStart;
                    const endHour = punch.personnelRequisitionDetail?.attendanceConfirmationEnd;

                    let isInTimeRange = false;

                    if (startHour != null && endHour != null && (startHour != 0 || endHour != 0)) {
                        if (startHour <= endHour) {
                            // Cas normal : 7.00 � 17.00
                            isInTimeRange = currentHour >= startHour && currentHour <= endHour;
                        } else {
                            // Cas chevauchant minuit : 22.00 � 6.00
                            isInTimeRange = currentHour >= startHour || currentHour <= endHour;
                        }
                    } else {
                        isInTimeRange = true;
                    }

                    if (isInTimeRange) {
                        this.setState({
                            useAttendanceConfirmationOnThisPunch: true
                        });

                        if (punch.attendanceConfirmation != null) {
                            this.setState({
                                lastAttendanceConfirmation: punch.attendanceConfirmation.confirmationTimestamp
                            });
                        }
                    }
                }
            }
            else {
                this.setState(
                    {
                        activeMessage: '',
                        activeLocationID: null,
                        activeJobTitle: '',
                        activeDepartment: '',
                        activeProject: '',
                        activeActivityProject: '',
                        isActivePunch: false,
                        comments: '',
                        activePunchID: null
                    });
            }
            resolve();
        })
    }

    loadLocations = () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.locations;

            if (list === null || list.length <= 0) {
                this.setState({ loading: this.state.isGeolocationEnabled && this.state.useGeolocation && this.state.useGeolocationZone }, () => {
                    resolve();
                    return;
                });

                return;
            }

            const defaultLocation = list[0].geolocationId;

            this.setState(
                {
                    locations: sortLocationByCode(list),
                    location: this.state.activeLocationID != null ? this.state.activeLocationID : defaultLocation
                });

            let zone;
            let locationValidator = this.state.activeLocationID != null ? this.state.activeLocationID : defaultLocation;

            for (var i = 0; i < this.state.locations.length; i++) {
                if (this.state.locations[i].geolocationId === locationValidator) {
                    zone = this.state.locations[i].Zone;
                    break;
                }
            }

            if (zone != null) {
                this.setState({ currentZone: JSON.parse(zone) });
            }
            resolve();
        })
    }

    loadProjects = () => {
        return new Promise(async (resolve) => {
            if (!this.state.abcUsage && !this.state.companyPayProject) {
                resolve();
                return;
            }
            let list;
            let defaultProject;

            if (!this.state.abcUsage) {
                list = await this.handleProfilePayProject();
                defaultProject = list.length > 0 ? list[0].project : '';
            } else {
                list = this.state.listComplete.projects;
                defaultProject = list.length > 0 ? list[0].project : '';

                if (this.state.location !== 0) {
                    list = list.filter(item => item.geolocationId == this.state.location || item.geolocationId === 0);

                    let projectItem = list.filter(item => item.project == defaultProject && item.geolocationId === this.state.location);
                    if (projectItem.length === 0) {
                        defaultProject = null;
                    } else {
                        const index = list.findIndex(item => item.project == defaultProject && item.geolocationId === 0);
                        if (index >= 0) {
                            list.splice(index, 1);
                        }
                    }
                }
            }

            const projectsSorted = sortProjectByCode(list);

            this.setState(
                {
                    projects: projectsSorted,
                    project: this.state.activeProject != '' ? this.state.activeProject : (defaultProject == null ? projectsSorted[0].project : defaultProject)
                }, () => resolve());
        });
    }

    loadActivities = () => {
        return new Promise((resolve) => {
            if (!this.state.abcUsage && !this.state.companyPayActivity) {
                resolve();
                return;
            }

            let list = this.state.listComplete.activities;

            if (this.state.abcUsage || (this.state.companyPayProject && this.state.linkProjectPActivity)) {
                list = list.filter(item => item.project == this.state.project);
            }

            const defaultActivity = list.length > 0 ? this.state.companyPayActivity ? list[0].activitySequence : list[0].activity : "";

            this.setState(
                {
                    activities: sortActivityByCode(list),
                    activity: this.state.activeActivityProject != '' ? this.state.activeActivityProject : defaultActivity
                }, () => resolve());
        });
    }

    loadDepartments = () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.departments;

            const defaultDepartment = list[0].departmentCode;

            this.setState(
                {
                    departments: sortDepartmentByCode(list),
                    department: this.state.activeDepartment != '' ? this.state.activeDepartment : defaultDepartment
                }, () => resolve());
        })
    }

    loadJobTitles = () => {
        return new Promise(async (resolve) => {
            //const list = this.state.listComplete.jobs;
            const list = await this.handleProfileJobTitle();

            const defaultJobTitles = list.length > 0 ? list[0].jobCode : '';

            this.setState(
                {
                    jobTitles: sortJobTitleByCode(list),
                    jobTitle: this.state.activeJobTitle != '' ? this.state.activeJobTitle : defaultJobTitles
                }, () => resolve());
        })
    }

    loadProfileJobTitle = () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.profilesJobTitle;

            this.setState(
                {
                    profilesJobTitle: list
                }, () => resolve());
        });
    }

    loadProfilePayProject = () => {
        return new Promise((resolve) => {
            const list = this.state.listComplete.profilesPayProject;

            this.setState(
                {
                    profilesPayProject: list
                }, () => resolve());
        });
    }

    resizeForm = () => {
        return new Promise((resolve) => {
            setTimeout(() => {
                const height = window.innerHeight;
                const titleBar = $('#appBarTitle').height();
                const header = $('div[data-id=headerPunch]').height();
                const heightMenuFavorite = document.querySelector('#menuFavorite').clientHeight;
                const geoWarning = document.querySelector('#divGeoWarning')?.clientHeight ?? 0;

                const customHeight = height - header - titleBar - heightMenuFavorite - geoWarning;

                const element = document.querySelector('#divPunchRoot');

                if (element !== undefined && element !== null) {
                    element.style.height = `${customHeight}px`;
                }
                resolve();
            }, 1000);
        })
    }

    onChangeProject = (event) => {
        this.setState({ project: event.target.value }, () =>
            this.loadActivities()
        );
    }

    onChangeActivity = (event) => {
        this.setState({ activity: event.target.value });
    }

    onChangeDepartment = (event) => {
        this.setState({ department: event.target.value }, () => {
            this.loadJobTitles();

            if (this.state.companyPayProject) {
                this.loadProjects();
            }
        });
    }

    onChangeJobTitle = (event) => {
        this.setState({ jobTitle: event.target.value });
    }

    onChangeComments = (event) => {
        this.setState({ comments: event.target.value });
    }

    onChangeLocation = (event) => {
        let zone = null;

        if (this.state.locations != null) {
            for (var i = 0; i < this.state.locations.length; i++) {
                if (this.state.locations[i].geolocationId === event.target.value) {
                    zone = this.state.locations[i].Zone;
                    break;
                }
            }

            if (zone != null) {
                this.setState({ currentZone: JSON.parse(zone) });
            }
        }

        this.setState({ location: event.target.value }, () => {
            if (this.state.abcUsage) {
                this.loadProjects();
            }
        });
    }

    handleProfileJobTitle = () => {
        return new Promise(resolve => {
            let list = this.state.listComplete.jobs;

            const filterJobTitle = [];

            this.state.profilesJobTitle.filter(item => item.department == this.state.department)
                .forEach(item => filterJobTitle.push(item.jobTitle))

            if (list.length > 0 && filterJobTitle.length > 0) {
                list = list.filter(item => filterJobTitle.includes(item.jobCode));
            }

            resolve(list);
        });
    }

    handleProfilePayProject = () => {
        return new Promise(resolve => {
            let list = this.state.listComplete.projects;

            const filterPayProject = [];

            this.state.profilesPayProject.filter(item => item.department == this.state.department)
                .forEach(item => filterPayProject.push(item.projectId))

            if (list.length > 0 && filterPayProject.length > 0) {
                list = list.filter(item => filterPayProject.includes(item.projectId));
            }

            resolve(list);
        });
    }

    validateForm = () => {
        return new Promise((resolve) => {
            let message = '';
            let error = false;

            if (this.state.location === '' || this.state.location === null) {
                message = i18next.t('punch:message.location-form');
                error = true;
            } else if ((this.state.abcUsage || this.state.companyPayProject) && (this.state.project === '' || this.state.project === null)) {
                message = i18next.t('punch:message.project-form');
                error = true;
            } else if ((this.state.abcUsage || this.state.companyPayActivity) && (this.state.activity === '' || this.state.activity === null)) {
                message = i18next.t('punch:message.activity-form');
                error = true;
            } else if (this.state.department === '' || this.state.department === null) {
                message = i18next.t('punch:message.department-form');
                error = true;
            } else if (this.state.jobTitle === '' || this.state.jobTitle === null) {
                message = i18next.t('punch:message.jobTitle-form');
                error = true;
            }

            if (error) {
                this.setState(
                    {
                        loading: false,
                        isPostCompleted: true
                    }, () => {
                        this.showMessageError(message);
                        resolve(false);
                    })
            }
            else {
                resolve(true);
            }
        })
    }

    showMessageError = (msg) => {
        this.alert.current.showMessageError(msg);
    }

    showMessageWarning = (msg) => {
        this.alert.current.showMessageWarning(msg);
    }

    showMessageSuccess = (msg) => {
        this.alert.current.showMessageSuccess(msg);
    }

    handleButtonClick = () => {
        if (!this.state.loading) {
            this.setState({ success: false, loading: true, isPostCompleted: false });

            const currentDate = new Date();
            const punchTime = currentDate.getFullYear() + "/" + (currentDate.getMonth() + 1) + "/" + currentDate.getDate() + " " + currentDate.getHours() + ":" + currentDate.getMinutes();

            this.validateForm().then(isValid => {
                if (isValid) {
                    addPunch(punchTime, this.state.location, this.state.project, this.state.activity,
                        this.state.department, this.state.jobTitle, this.state.comments,
                        this.state.latitude, this.state.longitude, true)
                        .then((response) => {
                            if (response == undefined || response.status == statusCode.STATUS_INTERNALSERVERERROR) {
                                this.showMessageError(i18next.t('error:generic-error'));
                                this.setState({ isPostCompleted: true, loading: false });
                                return;
                            }

                            //const result = JSON.parse(response.result);
                            const result = response;

                            if (result.codeReturn == 999) {
                                this.showMessageWarning(i18next.t('punch:limitTimeClientError'));
                                this.setState(
                                    {
                                        loading: false,
                                        isPostCompleted: true
                                    });
                            } else if (result.codeReturn < 0) {
                                this.showMessageWarning(result.message);
                                this.setState({ success: true, loading: false, isPostCompleted: true });
                            } else {
                                this.loadActivePunch(true);

                                this.setState({ success: true, loading: false, isPostCompleted: true });
                                this.showMessageSuccess(result.message);
                            }
                        }).catch(error => {
                            this.showMessageWarning('erro');
                        });
                }
            });
        }
    }

    handleButtonGeolocationClick = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                this.setState({ currentPosition: pos })
                this.setState({ openGeolocation: true });
            })
        }
    };

    handleButtonEmergencyClick = () => {
        this.setState({ openConfirmEmergency: true });
    };

    handleCloseConfirmEmergency = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ openConfirmEmergency: false });
    };

    handleButtonAttendanceConfirmationClick = () => {
        this.setState({ openAttendanceConfirmation: true });
    };

    handleAttendanceConfirmation = async () => {
        const response = await confirmAttendance(this.state.password, this.state.activePunchID, this.state.latitude, this.state.longitude);

        if (response != null && response.status == GenericStatusCode.NOT_VALIDATED) {
            // Error
            this.showMessageError(i18next.t('punch:attendanceConfirmation.attendanceConfirmationPasswordMessage'));
            return;
        } else if (response == null || (response != null && response.status != GenericStatusCode.SUCCESSFULL)) {
            // Error
            this.showMessageError(i18next.t('error:generic-error'));
            return;
        }
        this.setState(
            {
                openAttendanceConfirmation: false,
                lastAttendanceConfirmation: new Date()
            });
        this.showMessageSuccess(i18next.t('punch:attendanceConfirmation.confirmAttendanceSuccess'));
    };

    handleCloseAttendanceConfirmation = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ openAttendanceConfirmation: false });
    };

    handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    handleEmergency = async () => {
        const response = await confirmEmergency();

        if (response == null || (response != null && response.status != 0)) {
            // Error
            this.showMessageError(i18next.t('error:generic-error'));
            return;
        }

        this.setState({ openConfirmEmergency: false });
        this.showMessageSuccess(i18next.t('punch:attendanceConfirmation.emergencySuccess'));
    }

    handleCloseGeolocation = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ openGeolocation: false });
    }

    onAlertClick = (event, reason) => {
        this.loadDetail(this.state.activePunchID);
        this.setState({ openDetail: true });
    }

    handleCloseDetail = () => {
        this.setState({ openDetail: false });
    }

    handleChangePass = () => (event) => {
        this.setState({ password: event.target.value });
    };

    handleClickShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    loadDetail = (punchId) => {
        detailPunch(punchId).then((response) => {
            this.setState({ dataDetail: JSON.parse(response.detail) }, () => {
            });
        });
    }

    render() {
        const { t } = this.props;
        const { classes } = this.props;

        return (
            (!this.state.isGeolocationAvailable && this.state.useGeolocationMandatory)
                ? <div>{t('geolocation:message.error-support')}</div>
                : (!this.state.isGeolocationEnabled && this.state.useGeolocationMandatory)
                    ? <div className={classes.warningGeolocation}>{t('geolocation:message.error-enabled')}</div>
                    : <LoadingOverlay
                        className={classes.divLoading}
                        active={this.state.isActive || (this.state.isGeolocationEnabled && !this.state.coords && this.state.useGeolocation)}
                        spinner={<BeatLoader />}
                        text={(this.state.isGeolocationEnabled && !this.state.coords && this.state.useGeolocation) ? t('geolocation:message.load') : i18next.t('punch:form.loading')}
                    >
                        {!this.state.isGeolocationEnabled && this.state.useGeolocation &&
                            <div id="divGeoWarning" className={classes.warningGeolocation}>{t('geolocation:message.error-enabled')}</div>
                        }
                        <div id="divPunchRoot" className={styles.punchFormWrapper}>
                            {
                                <div data-id="divPunch" className={styles.divPunchForm}>
                                    {this.state.activeMessage &&
                                        <Alert className={styles.alert} severity={this.state.alertPunch} onClick={this.onAlertClick}>
                                            <AlertTitle>{this.state.activeMessage}</AlertTitle>
                                        </Alert>}
                                    <PunchDetail open={this.state.openDetail} onClose={this.handleCloseDetail} data={this.state.dataDetail} />

                                    <form onSubmit={this.handleSubmit} className={classes.form}>
                                        {this.state.isGeolocationEnabled && this.state.useGeolocation && this.state.useGeolocationZone && (<FormControl>
                                            <div className={styles.divFormSelect}>
                                                <InputLabel id="label-location">{t('punch:form.location')}</InputLabel>
                                                <Select
                                                    labelId="label-location"
                                                    id="location"
                                                    value={this.state.location}
                                                    onChange={this.onChangeLocation}
                                                    disabled={this.state.isActivePunch || this.state.punchTime}
                                                >
                                                    {this.state.locations.map((obj, index) =>
                                                        <MenuItem key={index} className={styles.selectItem} value={obj.geolocationId}>{`${obj.geolocationCode} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                                                    )}
                                                </Select>
                                            </div>
                                        </FormControl>)}

                                        {(this.state.abcUsage || this.state.companyPayProject) &&
                                            (
                                                <FormControl>
                                                    <div className={styles.divFormSelect}>
                                                        <InputLabel id="label-project">{t('punch:form.project')}</InputLabel>
                                                        <Select
                                                            labelId="label-project"
                                                            id="project"
                                                            value={this.state.project || ''}
                                                            onChange={this.onChangeProject}
                                                            disabled={this.state.isActivePunch || this.state.punchTime}
                                                        >
                                                            {this.state.projects.map((obj, index) =>
                                                                <MenuItem key={index} className={styles.selectItem} value={obj.project}>{`${obj.project} - ${IsEnglish() ? obj.projectEn : obj.projectFr}`}</MenuItem>
                                                            )}
                                                        </Select>
                                                    </div>
                                                </FormControl>
                                            )
                                        }

                                        {(this.state.abcUsage || this.state.companyPayActivity) &&
                                            (
                                                <FormControl>
                                                    <div className={styles.divFormSelect}>
                                                        <InputLabel id="label-activity">{t('punch:form.activity')}</InputLabel>
                                                        <Select
                                                            labelId="label-activity"
                                                            id="activity"
                                                            value={this.state.activity || ''}
                                                            onChange={this.onChangeActivity}
                                                            disabled={this.state.isActivePunch || this.state.punchTime}
                                                        >
                                                            {this.state.activities.map((obj, index) =>
                                                                <MenuItem key={index} className={styles.selectItem} value={this.state.companyPayActivity ? obj.activitySequence : obj.activity}>{`${obj.activity} - ${IsEnglish() ? obj.activityEn : obj.activityFr}`}</MenuItem>
                                                            )}
                                                        </Select>
                                                    </div>
                                                </FormControl>
                                            )
                                        }

                                        <FormControl>
                                            <div className={styles.divFormSelect}>
                                                <InputLabel id="label-department">{t('punch:form.department')}</InputLabel>
                                                <Select
                                                    labelId="label-department"
                                                    id="department"
                                                    value={this.state.department || ''}
                                                    onChange={this.onChangeDepartment}
                                                    disabled={this.state.isActivePunch || this.state.punchTime}
                                                >
                                                    {this.state.departments.map((obj, index) =>
                                                        <MenuItem key={index} className={styles.selectItem} value={obj.departmentCode}>{`${obj.departmentCode} - ${IsEnglish() ? obj.descriptionE : obj.descriptionF}`}</MenuItem>
                                                    )}
                                                </Select>
                                            </div>
                                        </FormControl>

                                        <FormControl>
                                            <div className={styles.divFormSelect}>
                                                <InputLabel id="label-jobTitle">{t('punch:form.jobTitle')}</InputLabel>
                                                <Select
                                                    labelId="label-jobTitle"
                                                    id="jobTitle"
                                                    value={this.state.jobTitle || ''}
                                                    onChange={this.onChangeJobTitle}
                                                    disabled={this.state.isActivePunch || this.state.punchTime}
                                                >
                                                    {this.state.jobTitles.map((obj, index) =>
                                                        <MenuItem key={index} className={styles.selectItem} value={obj.jobCode}>{`${obj.jobCode} - ${IsEnglish() ? obj.jobDescriptionEnglish : obj.jobDescriptionFrench}`}</MenuItem>
                                                    )}
                                                </Select>
                                            </div>
                                        </FormControl>

                                        <FormControl fullWidth>
                                            <TextField
                                                id="comments"
                                                label={t('punch:form.comments')}
                                                multiline
                                                minRows={4}
                                                className={styles.inputComments}
                                                onChange={this.onChangeComments}
                                                value={this.state.comments}
                                            />
                                        </FormControl>

                                        {this.state.isActivePunch && this.state.useFilePunch &&
                                            <PunchFileUpload punchId={this.state.activePunchID} isEnabled={true} />
                                        }

                                        <FormControl>
                                            {this.state.activePunchID && <PunchReportRoot punchId={this.state.activePunchID} isEnabled={true} /> }
                                            <ButtonLoad
                                                loading={!this.state.isPostCompleted}
                                                className={styles.punchButton}
                                                disabled={this.state.loading}
                                                onClick={this.handleButtonClick}
                                                variant="success"
                                            >
                                                {t('punch:button.punch')}
                                            </ButtonLoad>
                                            {this.state.isGeolocationEnabled && this.state.useGeolocation && <Button
                                                className={styles.punchGeolocation}
                                                color="primary"
                                                disabled={this.state.loading}
                                                onClick={this.handleButtonGeolocationClick}
                                                endIcon={<FontAwesomeIcon icon={faMapLocationDot} />}
                                            >
                                                {t('punch:button.map')}
                                            </Button>}
                                        </FormControl>

                                        {(this.state.useAttendanceConfirmationOnThisPunch && this.state.isActivePunch) &&
                                            <>
                                                <div className={styles.attendanceConfirmationContainer}>
                                                    <FormControl>
                                                        <Button
                                                            className={styles.punchAttendanceConfirmation}
                                                            color="primary"
                                                            disabled={this.state.loading}
                                                            onClick={this.handleButtonAttendanceConfirmationClick}
                                                            endIcon={<FontAwesomeIcon icon={faCircleCheck} />}
                                                        >
                                                            {t('punch:attendanceConfirmation.confirmAttendanceButton')}
                                                        </Button>
                                                    </FormControl>
                                                    <FormControl>
                                                        <Button
                                                            className={styles.punchAttendanceEmergency}
                                                            color="primary"
                                                            disabled={this.state.loading}
                                                            onClick={this.handleButtonEmergencyClick}
                                                            endIcon={<FontAwesomeIcon icon={faLightEmergencyOn} />}
                                                        >
                                                            {t('punch:attendanceConfirmation.emergencyButton')}
                                                        </Button>
                                                    </FormControl>
                                                </div>
                                                {this.state.lastAttendanceConfirmation != null &&
                                                    <p className={styles.lastAttendanceConfirmation}>{i18next.t('punch:attendanceConfirmation.lastAttendanceConfirmationMessage') + formatDate(this.state.lastAttendanceConfirmation, 'time')}</p>
                                                }

                                            </>
                                        }

                                        <Dialog fullScreen open={this.state.openGeolocation} onClose={this.handleCloseGeolocation} TransitionComponent={Transition}>
                                            <AppBar className={classes.appBar}>
                                                <Toolbar>
                                                    <IconButton edge="start" color="inherit" onClick={this.handleCloseGeolocation} aria-label="close">
                                                        <CloseIcon />
                                                    </IconButton>
                                                    <Typography variant="h6" className={classes.title}>
                                                        {i18next.t('punch:button.map')}
                                                    </Typography>
                                                </Toolbar>
                                            </AppBar>
                                            <PunchGeolocation currentPosition={this.state.currentPosition} currentZone={this.state.currentZone} />
                                        </Dialog>

                                        {!this.state.isSSO &&
                                            <Dialog fullScreen open={this.state.openAttendanceConfirmation} onClose={this.handleCloseAttendanceConfirmation} TransitionComponent={Transition}>
                                                <AppBar className={classes.appBar}>
                                                    <Toolbar>
                                                        <IconButton edge="start" color="inherit" onClick={this.handleCloseAttendanceConfirmation} aria-label="close">
                                                            <CloseIcon />
                                                        </IconButton>
                                                        <Typography variant="h6" className={classes.title}>
                                                            {i18next.t('punch:attendanceConfirmation.confirmationTitle')}
                                                        </Typography>
                                                    </Toolbar>
                                                </AppBar>
                                                <div className={styles.openAttendanceConfirmationDialog}>
                                                    <p className={styles.attendanceConfirmationInstructions}>{i18next.t('punch:attendanceConfirmation.confirmationInstructions')}</p>
                                                    <TextField
                                                        className={styles.input}
                                                        id="password"
                                                        name="password"
                                                        type={this.state.showPassword ? 'text' : 'password'}
                                                        onChange={this.handleChangePass()}
                                                        tabIndex={1}
                                                        variant="outlined"
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <FontAwesomeIcon icon={faLock} className={styles.icon_password} />
                                                                </InputAdornment>
                                                            ),
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton
                                                                        aria-label="toggle password visibility"
                                                                        onClick={this.handleClickShowPassword}
                                                                        onMouseDown={this.handleMouseDownPassword}
                                                                        className={styles.eyeIcon}
                                                                    >
                                                                        <FontAwesomeIcon icon={this.state.showPassword ? faEye : faEyeSlash} className={styles.icon_passwordVisibility} />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                    <FormControl>
                                                        <Button
                                                            className={styles.confirmAttendanceButton}
                                                            color="primary"
                                                            disabled={this.state.loading}
                                                            onClick={this.handleAttendanceConfirmation}
                                                        >
                                                            {t('punch:attendanceConfirmation.confirmButton')}
                                                        </Button>
                                                    </FormControl>
                                                </div>
                                            </Dialog>
                                        }

                                        {this.state.isSSO &&
                                            <Dialog
                                                open={this.state.openAttendanceConfirmation}
                                                onClose={this.handleCloseAttendanceConfirmation}
                                                aria-labelledby="draggable-dialog-title"
                                            >
                                                <DialogTitle id="draggable-dialog-title">
                                                    Confirmation
                                                </DialogTitle>
                                                <DialogContent>
                                                    <DialogContentText>
                                                        {i18next.t('punch:attendanceConfirmation.attendanceConfirmationMessage')}
                                                    </DialogContentText>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button autoFocus onClick={() => this.handleAttendanceConfirmation()} color="primary" className={styles.buttonYesNo} variant="text">
                                                        {i18next.t('buttons:yes')}
                                                    </Button>
                                                    <Button onClick={this.handleCloseAttendanceConfirmation} color="primary" className={styles.buttonYesNo} variant="text">
                                                        {i18next.t('buttons:no')}
                                                    </Button>
                                                </DialogActions>
                                            </Dialog>
                                        }

                                        <Dialog
                                            open={this.state.openConfirmEmergency}
                                            onClose={this.handleCloseConfirmEmergency}
                                            aria-labelledby="draggable-dialog-title"
                                        >
                                            <DialogTitle id="draggable-dialog-title">
                                                Confirmation
                                            </DialogTitle>
                                            <DialogContent>
                                                <DialogContentText>
                                                    {i18next.t('punch:attendanceConfirmation.emergencyMessage')}
                                                </DialogContentText>
                                            </DialogContent>
                                            <DialogActions>
                                                <Button autoFocus onClick={() => this.handleEmergency()} color="primary" className={styles.buttonYesNo} variant="text">
                                                    {i18next.t('buttons:yes')}
                                                </Button>
                                                <Button onClick={this.handleCloseConfirmEmergency} color="primary" className={styles.buttonYesNo} variant="text">
                                                    {i18next.t('buttons:no')}
                                                </Button>
                                            </DialogActions>
                                        </Dialog>
                                    </form>
                                </div>
                            }
                            <AlertAlgo ref={this.alert} />
                        </div>
                    </LoadingOverlay>
        )
    }
}

export default withNamespaces(['punch', 'geolocation', 'error', 'buttons', 'dailyReport', 'eventReport', 'weekday'], { wait: true })((withStyles(stylesMat)(PunchForm)));